import { HeadingMedium } from 'baseui/typography';
import ContentContainer from '../ContentContainer';
import { MatchingProvider, RequestEditorForMatchingProvider } from '../context/';
import MatchModal from './MatchModal';
import UnmatchedProjectsTable from './UnmatchedProjectsTable';
export function MatchingPanel() {
  return <MatchingProvider>
      <RequestEditorForMatchingProvider>
        <ContentContainer>
          <HeadingMedium>Matching Requests</HeadingMedium>
          <UnmatchedProjectsTable />
          <MatchModal />
        </ContentContainer>
      </RequestEditorForMatchingProvider>
    </MatchingProvider>;
}
export default MatchingPanel;